import { BaseService } from './base';
import { ReservationCancellationType } from '../models/reservationCancellationType';

export class ReservationCancellationTypeService extends BaseService<ReservationCancellationType> {
  override model = ReservationCancellationType;
  override modelName = 'reservationCancellationType';
  override modelLabel = 'Cancellation Reason';
}
